import { render } from "./CustomerData.vue?vue&type=template&id=756df820"
import script from "./CustomerData.vue?vue&type=script&lang=js"
export * from "./CustomerData.vue?vue&type=script&lang=js"

import "./CustomerData.vue?vue&type=style&index=0&id=756df820&lang=css"
import "./CustomerData.vue?vue&type=style&index=1&id=756df820&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__